import profilePic from '@assets/images/adminProfile.png';
import { Avatar, ConversationHeader } from '@chatscope/chat-ui-kit-react';
import { Stack, Text } from '@components/ui';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { useTranslation } from 'react-i18next';

interface ChatDialogHeaderProps {
  onClose: () => void;
  as?: 'ConversationHeader';
}

const ChatDialogHeader = ({ onClose }: ChatDialogHeaderProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <ConversationHeader>
      <Avatar src={profilePic} name={t('chat.brand')} />
      <ConversationHeader.Content>
        <Stack gap="xs" sx={{ minWidth: 0, gap: '1px' }}>
          <Text
            variant="subtitle"
            sx={{
              fontSize: '0.95rem',
              fontWeight: 700,
              lineHeight: 1.2,
              letterSpacing: '0.02em',
            }}
          >
            {t('chat.brand')}
          </Text>
          <Text
            variant="caption"
            tone="muted"
            sx={{ fontSize: '0.72rem', fontWeight: 500 }}
          >
            {t('chat.support')}
          </Text>
        </Stack>
      </ConversationHeader.Content>
      <ConversationHeader.Actions>
        <IconButton
          aria-label={t('chat.close')}
          type="button"
          onClick={onClose}
          sx={{
            p: 0.75,
            color: 'text.secondary',
            '&:hover': { bgcolor: 'action.hover', color: 'text.primary' },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </ConversationHeader.Actions>
    </ConversationHeader>
  );
};

export default ChatDialogHeader;
